import cn from 'classnames';
import { FC, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useSearchParams } from 'react-router';
import { ClipLoader } from 'react-spinners';

import loadingCat from '@/shared/assets/images/cats/loading.png';
import sadCat from '@/shared/assets/images/cats/sad.png';

import {
  buildTranscriptorDeepLinkPath,
  TRANSCRIPTOR_LANDING_PATIENT_ID_PARAM,
} from '@/features/transcriptorDeepLink';

import styles from './TranscriptorLanding.module.scss';

type TranscriptorLandingProps = {
  className?: string;
};

export const TranscriptorLanding: FC<TranscriptorLandingProps> = (props) => {
  const { className } = props;

  const { formatMessage } = useIntl();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const patientID = searchParams.get(TRANSCRIPTOR_LANDING_PATIENT_ID_PARAM);

  useEffect(() => {
    if (!patientID) {
      return;
    }

    navigate(buildTranscriptorDeepLinkPath({ patientID, searchParams }), {
      replace: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientID]);

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.wrap}>
        <div className={styles.content}>
          {patientID ? (
            <>
              <img
                src={loadingCat}
                width={130}
                height={130}
                alt={formatMessage({
                  id: 'imgAltText.loadingCat',
                  defaultMessage: 'Loading cat',
                })}
              />
              <div className={cn(styles.loading, 'p1')}>
                <FormattedMessage
                  id="transcriptorLanding.loading"
                  defaultMessage="Opening patient profile..."
                />
                <ClipLoader size={32} />
              </div>
            </>
          ) : (
            <>
              <img
                src={sadCat}
                width={130}
                height={130}
                alt={formatMessage({
                  id: 'imgAltText.sadCat',
                  defaultMessage: 'Sad cat',
                })}
              />
              <div className="p1">
                <FormattedMessage
                  id="transcriptorLanding.missingPatient.label"
                  defaultMessage="Patient not specified"
                />
              </div>
              <div className={cn(styles.message, 'p2')}>
                <FormattedMessage
                  id="transcriptorLanding.missingPatient.message"
                  defaultMessage="The link is missing the patient identifier. Please open the recording from your practice management system again or contact support."
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
